"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMobile = exports.name = void 0;
var bowser_1 = __importDefault(require("bowser"));
var APPLE_MOBILE_DEVICES = [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod',
];
var _a = globalThis.navigator, userAgent = _a.userAgent, platform = _a.platform, maxTouchPoints = _a.maxTouchPoints;
// this detects ipad properly in safari
// while bowser does not
var isIOS = APPLE_MOBILE_DEVICES.includes(platform) || (userAgent.includes('Mac') && 'ontouchend' in document);
// Edge case: iPad is included in this function
// Keep in mind maxTouchPoints for Vision Pro might change in the future
var isVisionOS = userAgent.includes('Macintosh') && maxTouchPoints === 5;
var bowser = bowser_1.default.getParser(userAgent);
var os = bowser.getOSName().toLowerCase();
var name = isVisionOS ? 'visionos' : isIOS ? 'ios' : os || 'unknown';
exports.name = name;
var isMobile = ['ios', 'android'].includes(name);
exports.isMobile = isMobile;
